import { createContext, useContext } from 'react';

const AddonsBuyContext = createContext({});

AddonsBuyContext.displayName = 'AddonsBuyContext';

const useAddonsBuy = () => useContext(AddonsBuyContext);

export { AddonsBuyContext, useAddonsBuy };
